// import Procedure from './Procedure';

export default {
  priority: 96,
  path: 'procedure',
  permissions:['RequestsMenu/WorkflowMenu'],// ['WorkflowMenu'],
  icon: 'message-processing',
  // component: Procedure,
  // component: load(() => import(/* webpackChunkName: "Requests-Procedure" */ './Procedure')),
  name: app.translate('routes.home.requests.Procedure'),
  drawer: true,
};


